import Title1 from "./title1"
import Title2 from "./title2"
import Title3 from "./title3"


export default function Title({ options, data })
{
    const type = options.type

    if(type === 1) {
        return (
            <Title1 
                options={options}
                data={data}
            />
        )
    }

    if(type === 2) {
        return (
            <Title2 
                options={options}
                data={data}
            />
        )
    }

    if(type === 3) {
        return (
            <Title3 
                options={options}
                data={data}
            />
        )
    }

    return <></>
}